import React from 'react'
import Svg from './Svg'
export const SvgForm = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M21.003 5.554L15.82.557A1.981 1.981 0 0014.447 0H4.918a1.998 1.998 0 00-1.953 2.005v19.99c0 1.107.892 2.005 1.992 2.005h14.674c1.1 0 1.992-.898 1.992-2.005V7.002a2.03 2.03 0 00-.62-1.448zm-2.41.451h-3.155V2.954zM4.957 21.995V2.005h8.499v4.997c0 .53.427.959.953.959h5.222v14.034z" />
  </Svg>
))
SvgForm.isIcon = true
export default SvgForm
